type NavigationCallback = () => void;
// eslint-disable-next-line
const noop = () => {};

export const navigate = (path: string, callback: NavigationCallback = noop): void => {
  if (path.trim().length === 0) {
    throw Error(`You have to include a path, current value: ${path}`);
  }

  if (path[0] !== '/') {
    throw Error(`You have to include a path starting with "/", current value: ${path}`);
  }

  callback();

  window.location.href = `${window.location.origin}${path}`;
};
